import React, { Component } from 'react';
import CheckboxInputBuilder from './CheckboxInputBuilder';
import RadioInputBuilder from './RadioInputBuilder';
require('formdata-polyfill')

class Searchform extends Component {
  constructor(props){
    super(props)
    this.state = {
      CheckboxInputBuilder: null,
      RadioInputBuilder: null,
      do_array: this.props.parameterDo,
      cpn: this.props.parameterCpn,
      ord: this.props.parameterOrd,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange (e, i) {
    const {name} = e.target
    const changeCheck = key => state =>{
      const changeKey = state[key].map((item, j) =>{
        if(name === "cpn" || name === "ord" || i === 0){
          if(j === i){
            item.inputChecked = true
            return item
          }else{
            item.inputChecked = false
            return item
          }
        }else{
          if(j === i){
            item.inputChecked ? item.inputChecked = false : item.inputChecked = true
            return item
          }else{
            if(item.inputValue === "all"){
              item.inputChecked = false
            }
            return item
          }
        }
      })
      return{
        [key] : changeKey
      }
    }
    this.setState(changeCheck(name))
  }

  handleSubmit (event) {
    event.preventDefault()
    let data = new FormData(event.target)
    let submit_values = []

    submit_values.push("ie="+data.get('ie'))
    submit_values.push("domain="+data.get('domain'))

    let kw_value = encodeURI(data.get('kw'))
    if(kw_value){
      submit_values.push("kw="+kw_value)
    }
    submit_values.push("cpn="+data.get('cpn'))
    submit_values.push("ord="+data.get('ord'))

    let submit_do_elements = []
    for(let i=0; i<this.props.parameterDo.length; i++){
      this.props.parameterDo[i].inputChecked && submit_do_elements.push(encodeURI('do[]=')+this.props.parameterDo[i].inputValue);
    }

    if (window.history.replaceState) {
      let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' +submit_values.join('&') + "&" + submit_do_elements.join('&') + "&page=1";
      window.history.replaceState({path:newurl},'',newurl);
    }

    let search = "https://search.olympus-global.com?"+submit_values.join('&') + "&" + submit_do_elements.join('&') + "&page=1&sxml=on"
    //let search = "./search.xml?"+submit_values.join('&') + "&" + submit_do_elements.join('&') + "&page=1&sxml=on"

    this.props.loadSet(true)
    this.props.urlSet(search)

  }

  render() {
    return (
      <form name="search_form" className="form-search" onSubmit={this.handleSubmit}>
      <div className="form-search-inner">
      <input type="hidden" name="ie" defaultValue="u"/>
      <input type="hidden" name="domain" defaultValue="ja"/>
      <div className="form-search-ui">
      <p className="form-search-input">
      <input type="search" name="kw" className="searchBox ui-autocomplete-input" defaultValue={decodeURI(this.props.parameterKw)} autoComplete="off" aria-autocomplete="list" aria-haspopup="true"/>
      <button type="submit">検索</button>
      </p>
      </div>
      <dl className="form-search-option" id="search-option" aria-expanded="true">
      <dt>検索対象の絞込み</dt>
      <dd><ul>
      {
        this.props.parameterDo.map(({id, inputValue, inputLabel, inputChecked}) => (
          <CheckboxInputBuilder
            id={id}
            inputValue={inputValue}
            inputLabel={inputLabel}
            inputChecked={inputChecked}
            onClick={this.handleChange}
            key={id}
          />
        )
      )
      }
      </ul></dd>
      <dt className="col2">表示件数</dt><dd className="col2">
      <ul>
      {
        this.props.parameterCpn.map(({id, inputValue, inputLabel, inputName, inputChecked}) => (
          <RadioInputBuilder
            id={id}
            inputValue={inputValue}
            inputLabel={inputLabel}
            inputName={inputName}
            inputChecked={inputChecked}
            onClick={this.handleChange}
            key={id}
          />
        )
      )
      }
      </ul>
      </dd>
      <dt className="col2">表示順</dt><dd className="col2">
      <ul>
      {
        this.props.parameterOrd.map(({id, inputValue, inputLabel, inputName, inputChecked}) => (
          <RadioInputBuilder
            id={id}
            inputValue={inputValue}
            inputLabel={inputLabel}
            inputName={inputName}
            inputChecked={inputChecked}
            onClick={this.handleChange}
            key={id}
          />
        )
      )
      }
      </ul>
      </dd>
      </dl>
      </div>
      </form>
    )
  }
}

export default Searchform;
